import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { Lock } from "lucide-react";

export function PromoCountdown({ endsAt }) {
  const [left, setLeft] = useState(() => new Date(endsAt) - Date.now());
  useEffect(() => {
    const t = setInterval(() => setLeft(new Date(endsAt) - Date.now()), 1000);
    return () => clearInterval(t);
  }, [endsAt]);
  if (!endsAt || left <= 0) return null;
  const h = Math.floor(left / 3600000);
  const m = Math.floor((left % 3600000) / 60000);
  const s = Math.floor((left % 60000) / 1000);
  const pad = (n) => String(n).padStart(2, "0");
  return (
    <span className="font-data tabular-nums" data-testid="promo-countdown">
      ends in {h}h {pad(m)}m {pad(s)}s
    </span>
  );
}

export function UpgradeGate({ feature }) {
  return (
    <div className="card-gold border border-[#a855f7]/30 rounded-lg p-8 text-center gold-glow" data-testid="upgrade-gate">
      <Lock className="mx-auto text-[#a855f7] mb-3" size={28} />
      <h3 className="font-display text-2xl font-bold uppercase text-white">Pro Members Only</h3>
      <p className="text-neutral-400 text-sm mt-2 max-w-md mx-auto">
        {feature} is part of Pooh Sheet Pro. Upgrade monthly or grab a $9.99 Day Pass for 24 hours of full access.
      </p>
      <div className="mt-4 flex flex-wrap justify-center gap-3">
        <Link
          to="/settings"
          data-testid="upgrade-gate-cta"
          className="inline-block bg-[#a855f7] hover:bg-[#9333ea] text-black font-bold uppercase tracking-wider text-sm px-6 py-2.5 rounded transition-colors duration-200"
        >
          Upgrade to Pro
        </Link>
        <Link
          to="/settings"
          data-testid="upgrade-gate-daypass-cta"
          className="inline-block border border-[#a855f7]/50 hover:border-[#a855f7] text-[#a855f7] font-bold uppercase tracking-wider text-sm px-6 py-2.5 rounded transition-colors duration-200"
        >
          Day Pass $9.99
        </Link>
      </div>
    </div>
  );
}

export function Stars({ n }) {
  return (
    <span className="text-[#a855f7] tracking-tighter" aria-label={`${n} stars`}>
      {"★".repeat(n)}<span className="text-neutral-700">{"★".repeat(5 - n)}</span>
    </span>
  );
}

export function ConfBar({ value, className = "" }) {
  const color = value >= 7 ? "#22c55e" : value >= 4 ? "#f59e0b" : "#ef4444";
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex-1 h-1.5 bg-white/10 rounded-full overflow-hidden">
        <div className="h-full rounded-full transition-[width] duration-500" style={{ width: `${value * 10}%`, background: color }} />
      </div>
      <span className="font-data text-xs font-semibold" style={{ color }}>{Number(value).toFixed(1)}</span>
    </div>
  );
}

export function StatBar({ label, value, max = 100, suffix = "%", good = 0 }) {
  const pct = Math.min((value / max) * 100, 100);
  const isGood = good && value >= good;
  return (
    <div>
      <div className="flex justify-between text-xs mb-1">
        <span className="text-neutral-400 uppercase tracking-wider">{label}</span>
        <span className={`font-data font-semibold ${isGood ? "text-[#22c55e]" : "text-white"}`}>{value}{suffix}</span>
      </div>
      <div className="h-1.5 bg-white/10 rounded-full overflow-hidden">
        <div className={`h-full rounded-full ${isGood ? "bg-[#22c55e]" : "bg-[#a855f7]"}`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
